import { z } from "zod";

export const CreateTerminalSchema = z.object({
    nm_maquina: z.string()
        .nonempty("O nome da máquina é obrigatório.")
        .min(3, "O nome da máquina deve ter no mínimo 3 caracteres")
        .max(10, "O nome da máquina deve ter no máximo 10 caracteres"),

    cod_maquina: z.union([
        z.string()
            .nonempty("O código da máquina é obrigatório.")
            .min(2, "O código da máquina deve ter no mínimo 2 caracteres")
            .max(4, "O código da máquina deve ter no máximo 4 caracteres"),
        z.number()
            .min(10, "O código da máquina deve ter no mínimo 2 dígitos")
            .max(9999, "O código da máquina deve ter no máximo 4 dígitos")
    ])

});
